export default function () {
    const $plpBannerCarousel = $(".plp-banner-carousel .content-plus-container");
    const $plpBannerTitle = $(".plp-banner-title");

    if ($plpBannerCarousel.length === 0) {
        $plpBannerTitle.removeClass("d-none");
    }
}
